// react
import * as React from "react";
// global
import l10n = require("diy/util/l10n");
import Social from "diy/moments-to-celebrate/components/Social";
import websiteData = require("diy/util/websiteData");
// local
import {StepData} from "../StepData";
import {Observable} from "diy/util/Observable";
import {StepImage} from "./StepImage";
import {StepVimeo} from "./StepVimeo";
import {StepText} from "./StepText";
import {StepActions} from "./StepActions";

const DEFAULT_HELP_ID = 'guidedSetup';

export interface StepConfig {
    helpId?: string;
    imageId?: string;
    vimeoUrlIds?: LocalizedVimeoUrls;
    showSocialButtons?: boolean;
    renderDoableMessage?(): JSX.Element;
    onAction(): void;
}

export interface StepProps {
    stepData: StepData;
    stepConfig: StepConfig;
    observable: Observable;
    onBeforeHelp?(): void;
}

export interface LocalizedVimeoUrls {
    [language: string]: string;
}

export class Step extends React.Component<StepProps, {}> {

    constructor(props: StepProps, context: any) {
        super(props, context);
    };

    render() {
        const styles = this.getStyles();
        const {helpId, imageId, showSocialButtons} = this.props.stepConfig;

        return (
            <div style={styles.root}>
                <div className="panel-container" style={styles.mainPanel}>
                    {this.hasVimeo() ?
                        <StepVimeo videoId={this.getVimeoUrlId()} frameId={this.props.stepData.id + '_video'} />
                        : null }
                    {this.hasImage() ?
                        <StepImage imageUrl={cc_.cdnServer
                            + "s/diy/onboarding-guide/guide-images/step-visuals/"
                            + imageId + '.jpg'}
                        />
                        : null }
                    <div className="text-container" style={styles.textContainer}>
                        <StepText
                            title={l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.title')}
                            description={
                                l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.description')
                            }
                            showHelpIcon={helpId ? true : false}
                            onHelp={helpId ? () => this.helpClick() : null}
                        />
                        {this.props.stepData.doable ? null :
                            <div style={styles.notDoable} className="not-doable-reason">
                                {this.renderDoableMessage()}
                            </div>
                        }
                    </div>
                    {showSocialButtons ?
                        <div style={styles.socialWrapper}>
                            <Social trackingPageName="onboarding_guide" showShareMessage={false} />
                        </div>
                        : null}
                </div>
                <StepActions
                    onAction={() => this.onAction()}
                    label={l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.callToAction')}
                    disabled={!this.props.stepData.doable}
                />
            </div>
        );

    };

    onAction() {
        this.props.observable.notify({
            eventName: 'diy-editor-onboardingGuide-callToActionClick',
            step: this.props.stepData
        });
        this.props.stepConfig.onAction();
    };

    private hasVimeo() {
        const {vimeoUrlIds} = this.props.stepConfig;
        let lng = websiteData.getLanguage();
        return (
            vimeoUrlIds
            && vimeoUrlIds.hasOwnProperty(lng)
            && vimeoUrlIds[lng] !== null
        );
    }

    private getVimeoUrlId() {
        if (this.hasVimeo()) {
            return this.props.stepConfig.vimeoUrlIds[websiteData.getLanguage()];
        } else {
            throw new Error('Vimeo Url requested but not available');
        }
    }

    private hasImage() {
        return (this.props.stepConfig.imageId !== null);
    }

    private renderDoableMessage() {
        if (this.props.stepConfig.renderDoableMessage) {
            return this.props.stepConfig.renderDoableMessage();
        }
        return (<div>{l10n.getString('onboardingGuide.errors.stepNotDoable')}</div>);
    }

    private helpClick() {
        if (this.props.onBeforeHelp) {
            this.props.onBeforeHelp();
        }
        cms.help.GuidedAssistant.getInstance()
            ._openHelpTopic(this.props.stepConfig.helpId || DEFAULT_HELP_ID);
    }

    private getStyles() {
        return {
            notDoable: {
                marginTop: "8px",
                marginBottom: "8px"
            },
            root: {
                height: "534px",
                fontFamily: '"Open Sans", sans-serif'
            },
            mainPanel: {
                position: "relative",
                width: "100%",
                height: "482px",
                overflowY: "auto"
            },
            socialWrapper: {
                margin: "12px 0 0 0",
            },
            textContainer: {
                padding: "10px 32px 0 32px"
            },
        };
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/Step.tsx
 **/